import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  rpfTitle: 'Request payments with EFEX Payment Link',
  rpfMessage:
    'With EFEX Payment Link, you can request custom transfers by selecting the client, amount, spread, and deadline. Share the link via message or email, and your client can transfer to you instantly. Plus, you’ll have full control over the status of your payment links. Optimize your transfer flow with EFEX today!',
  rpfButton: 'Activate Payment Links',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const REQUEST_PAYMENT_FEATURE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    rpfTitle: 'Solicita tus transferencias con el Link de Cobro de EFEX',
    rpfMessage:
      'Con el link de cobro de EFEX, puedes solicitar transferencias personalizadas seleccionando el cliente, monto, spread y fecha límite. Comparte el link por mensaje o correo, y tu cliente podrá transferirte al instante. Además, tendrás control total sobre el estado de tus links de cobro. ¡Optimiza tu flujo de transferencias con EFEX hoy mismo!',
    rpfButton: 'Activar links de cobro',
  },
};

export default REQUEST_PAYMENT_FEATURE_LABELS;
